export type Language = 'cs' | 'en' | 'pl' | 'sk' | 'de' | 'it';

export const translations = {
  cs: {
    title: 'Aktuální slevové kupóny na Vedos.cz',
    subtitle: 'Využijte aktuální slevové kupóny a ušetřete na webhostingu, doménách a dalších službách.',
    cta: 'Přejít na Vedos.cz',
    homeTitle: 'Vedos Slevové Kupóny 2026 - Až 70% Sleva na Webhosting, VPS ON, VPS SSD a Domény',
    skipToContent: 'Přeskočit na obsah',
    privacyPolicy: 'Ochrana osobních údajů',
    discountCode: 'Slevový kód',
    validUntil: 'do',
    topCoupons: 'Top Slevové Kódy',
    moreInfo: 'Více informací',
    recommended: 'Doporučeno',
    site: {
      title: 'slevy-hosting-domeny.cz'
    },
    footer: {
      aboutTitle: 'O projektu',
      aboutText1: 'shromažďuje aktuální slevové kódy na služby Vedos.cz (webhosting, WordPress hosting, VPS, domény a další).',
      aboutText2: 'Tento web je pouze informativní a může obsahovat affiliate odkazy. Kliknutím na odkaz podpoříte provoz projektu a získáte slevu na produkty.',
      linksTitle: 'Odkazy',
      links: {
        home: 'Domů',
        blog: 'Blog',
        privacy: 'Ochrana osobních údajů'
      },
      servicesTitle: 'Další služby',
      services: {
        vinInfo: 'VIN Info.cz — kontrola vozidla',
        fixweb: 'FixWeb.cz — opravy webů',
        dealora: 'Dealora.cz — slevové kódy',
        openShops: 'Jsou obchody otevřené?',
        kurzyKaret: 'KurzyKaret.cz — kurzy při platbě kartou'
      }
    },
    blog: {
      title: 'Blog',
      subtitle: 'Praktické návody, srovnání a tipy pro výběr hostingu, WordPressu, VPS a domén.',
      pageTitle: 'Blog | slevy-hosting-domeny.cz',
      readMore: 'Číst článek',
      openOffer: 'Otevřít nabídku',
      relatedOffers: 'Související nabídky',
      published: 'Publikováno',
      updated: 'Aktualizováno',
      minutes: 'min čtení',
      lessThanMinute: '< 1 min čtení',
      backToBlog: 'Zpět na blog',
      noPostsForLanguage: 'Pro tento jazyk zatím nejsou dostupné články.',
      csOnlyShort: 'Obsah je česky',
      csOnlyNotice: 'Obsah tohoto článku je aktuálně dostupný pouze v češtině.',
      languageMismatchNotice: 'Tento článek je dostupný v jiném jazyce. Níže vidíte původní verzi článku.',
      notFoundTitle: 'Článek nebyl nalezen',
      notFoundText: 'Zkuste si vybrat některý z článků v blogu.'
    },
    coupons: {
      webhostingNoLimit: 'Webhosting NoLimit a Extra sleva 70 %',
      webhostingLowCost: 'Webhosting LowCost, NoLimit a Extra sleva 60 %',
      domains: '50% sleva na domény (.EU, .ONLINE, .STORE, .TECH, .SITE, .WEBSITE, .SPACE, .FUN)',
      vpsOn: 'VPS ON sleva 33 %',
      vpsSsd: 'VPS SSD sleva 25 %',
      wordpressHosting: 'WordPress hosting (WP LowCost + WP NoLimit) sleva 50 %',
      website: 'VEDOS WebSite sleva 50 %',
      // cd: 'VEDOS CD sleva 25 %',
      disk: 'VEDOS Disk sleva 25 %',
      mailhosting: 'Mailhosting sleva 50 %',
      renewal: 'Sleva na PRODLOUŽENÍ',
      renewalInfo: {
        text: '(max. 300x). Případně zkuste najít v',
        linkText: 'aktuálním newsletteru',
        linkUrl: 'https://www.vedos.cz/newsletter?ap=Lf2pCY'
      },
      allCodes: 'Dostupné Slevové Kódy'
    },
    services: {
      webhostingNoLimit: {
        title: 'Webhosting NoLimit',
        content: 'Nejprodávanější a nejoblíbenější webhosting v České republice, ideální pro WordPress, e-shopy a náročnější projekty. Neomezený prostor, stabilní výkon a nonstop podpora.',
        cta: 'Objednat se slevou 70%'
      },
      webhostingLowCost: {
        title: 'Webhosting LowCost a NoLimit',
        content: 'Sleva 60% na Webhosting LowCost a NoLimit - ideální řešení pro menší i větší projekty.',
        cta: 'Objednat se slevou 60%'
      },
      domains: {
        title: 'Domény',
        content: '50% sleva na domény .EU, .ONLINE, .STORE, .TECH, .SITE, .WEBSITE, .SPACE a .FUN. Registrujte si svou doménu výhodně!',
        cta: 'Registrovat se slevou 50%'
      },
      vpsOn: {
        title: 'VPS ON',
        content: 'Virtuální servery na cloudové infrastruktuře OpenNebula. Plaťte jen za to, co potřebujete! Zvolte si RAM, diskový prostor (100% SSD) a počet CPU jader.',
        cta: 'Získat VPS ON se slevou 33%'
      },
      vpsSsd: {
        title: 'VPS SSD',
        content: 'Výkonné virtuální servery s vyhrazeným výkonem a SSD disky. Garantovaný výkon a dostupnost pro vaše náročné projekty.',
        cta: 'Získat VPS SSD se slevou 25%'
      },
      wordpressHosting: {
        title: 'WordPress hosting',
        content: 'Speciální 50% sleva na WordPress hosting WP LowCost a WP NoLimit. Ideální volba pro rychlé a bezpečné WordPress weby s českou podporou.',
        cta: 'Získat WordPress hosting se slevou 50%'
      },
      website: {
        title: 'VEDOS WebSite',
        content: 'Vytvořte si vlastní web jednoduše a rychle. Nyní se slevou 50% na službu VEDOS WebSite.',
        cta: 'Vytvořit web se slevou 50%'
      },
      // cd: {
      //   title: 'VEDOS CD',
      //   content: 'Cloudové úložiště pro vaše data. Využijte 25% slevu na VEDOS CD služby.',
      //   cta: 'Aktivovat se slevou 25%'
      // },
      disk: {
        title: 'VEDOS Disk',
        content: 'Bezpečné záložní úložiště pro vaše data. Holý diskový prostor s přístupem přes FTP, rsync, SMB, SVN a Git. Od 30 GB do násobků TB.',
        cta: 'Získat se slevou 25%'
      },
      mailhosting: {
        title: 'Mailhosting',
        content: 'Moderní e-mail na vlastní doméně s českou podporou. Stabilní a bezpečná služba s daty uloženými výhradně v datacentru v ČR.',
        cta: 'Získat mailhosting se slevou 50%'
      },
      renewal: {
        title: 'Prodloužení služeb',
        content: 'Speciální sleva na prodloužení stávajících služeb (max. 300x).',
        cta: 'Prodloužit služby'
      }
    },
    seo: {
      useCode: 'Využijte náš exkluzivní slevový kód',
      saveOnServices: 'a ušetřete na službách Vedos.cz. Tento kupón je platný do',
      significantDiscount: 'a poskytuje významnou slevu na',
      aboutVedos: 'Vedos.cz je jedním z předních poskytovatelů webhostingu a doménových služeb v České republice. Naše slevové kupóny vám umožňují získat kvalitní služby za výhodné ceny.',
      howToUse: 'Jak použít slevový kód',
      step1: 'Klikněte na tlačítko',
      step2: 'Vyberte požadovanou službu nebo balíček',
      step3: 'V košíku zadejte slevový kód:',
      step4: 'Dokončete objednávku s aplikovanou slevou',
      whyChoose: 'Proč vybrat Vedos.cz',
      reason1: 'Více než 15 let zkušeností na trhu',
      reason2: 'Spolehlivé služby s vysokou dostupností',
      reason3: 'Česká technická podpora',
      reason4: 'Konkurenceschopné ceny',
      reason5: 'Moderní technologie a infrastruktura',
      moreCoupons: 'Další slevové kupóny',
      exploreMore: 'Prozkoumejte další dostupné slevy na služby Vedos.cz',
      allCoupons: 'Všechny kupóny',
      above: 'výše',
      faqTitle: 'Nejčastější otázky',
      long: {
        webhostingNoLimit: 'Webhosting NoLimit je ideální volba pro projekty, které potřebují vyvážený poměr výkonu, stability a ceny. Díky neomezenému prostoru a vysoké dostupnosti zvládne WordPress, WooCommerce i náročnější redakční systémy. V kombinaci s pravidelnými slevovými akcemi jde o jednu z nejvýhodnějších nabídek na trhu.\n\nV rámci balíčku získáte moderní technologii, českou podporu a transparentní ceník bez skrytých poplatků. Přenést web k poskytovateli je snadné a většinu běžných webů zprovozníte během několika minut.',
        webhostingLowCost: 'LowCost i NoLimit pokrývají potřeby většiny webů. LowCost je skvělý začátek pro osobní stránky, blogy a menší firemní weby. Pokud plánujete růst, zvažte NoLimit se silnější konfigurací a lepšími parametry pro databáze a PHP.\n\nSlevové kódy pravidelně zlevňují jak zřizovací poplatek, tak první fakturační období, díky čemuž ušetříte hned na startu.',
        vpsOn: 'VPS ON je flexibilní řešení s možností nastavit parametry na míru – CPU, RAM i disk (100% SSD). Běží na ověřené infrastruktuře OpenNebula a hodí se pro aplikace, které vyžadují izolované prostředí, přístup root a možnost škálování.\n\nSleva Vám umožní otestovat produkční prostředí za nižší náklady a následně škálovat podle potřeby.',
        vpsSsd: 'VPS SSD nabízí vyvážený poměr ceny a výkonu s garantovanými parametry v rámci modulů. Je ideální pro projekty, které vyžadují stabilní a predikovatelné prostředí. Díky SSD diskům jsou operace velmi rychlé.\n\nSleva se vztahuje na zřízení služby a umožňuje Vám začít s profesionálním virtuálním serverem za minimální náklady.',
        wordpressHosting: 'WordPress hosting WP LowCost a WP NoLimit je navržený speciálně pro rychlý provoz WordPress webů. Se slevou 50 % snadno spustíte blog, firemní web i e-shop na optimalizované infrastruktuře.\n\nSoučástí řešení je jednoduchá správa, stabilní výkon a prostředí připravené pro moderní WordPress.',
        domains: 'Registrace domény je prvním krokem k vlastnímu webu. S naší slevou získáte oblíbené koncovky jako .EU, .ONLINE nebo .STORE za zlomek běžné ceny. Výhodná cena platí pro první rok registrace a umožní Vám rezervovat si vysněný název bez velkých investic.\n\nKe každé doméně navíc získáte základní správu DNS a možnost snadného propojení s dalšími službami Vedos.',
        website: 'VEDOS WebSite umožňuje rychlé sestavení webu bez programování. Vyberete si šablonu, upravíte obsah a publikujete. Řešení je ideální pro živnostníky a malé firmy, které chtějí být online bez zbytečné složitosti.\n\nDíky akční slevě získáte profesionálně vypadající web za zlomek ceny oproti zakázkovému vývoji.',
        disk: 'VEDOS Disk je bezpečné vzdálené úložiště pro zálohy a archivaci. Přístup přes FTP, rsync, SMB, SVN či Git umožňuje snadnou integraci do Vašich procesů. Vhodné pro firmy i jednotlivce, kteří potřebují spolehlivý prostor mimo vlastní infrastrukturu.\n\nSlevový kód sníží náklady na dlouhodobé uchovávání dat.',
        mailhosting: 'Mailhosting na vlastní doméně posílí profesionální prezentaci firmy. Služba nabízí moderní webmail, antivirovou a antispamovou ochranu a data uložená v ČR. Snadno přidáte další schránky a nastavíte přesměrování či aliasy.\n\nSe slevou vyřešíte firemní e-mail rychle a levně.',
        renewal: 'Se slevou na prodloužení ušetříte při zachování stávajících parametrů služeb. Vhodné pro dlouhodobé projekty, kde se vyplatí stabilita a kontinuální provoz bez výpadků. Sledujte newsletter – často obsahuje výhodné kódy na více prodloužení.'
      },
      faqs: {
        webhostingNoLimit: [
          { q: 'Pro koho je NoLimit vhodný?', a: 'Pro firemní weby, blogy, magazíny i menší e‑shopy na WordPressu. Nabízí dostatek výkonu a neomezený prostor.' },
          { q: 'Lze přejít z LowCost na NoLimit?', a: 'Ano, přechod je možný kdykoliv. Parametry lze navýšit bez výpadku provozu.' },
          { q: 'Podporujete HTTPS a zálohy?', a: 'Ano, k dispozici je Let’s Encrypt/SSL a pravidelné zálohy dle podmínek služby.' }
        ],
        webhostingLowCost: [
          { q: 'Stačí LowCost pro menší web?', a: 'Ano, pro osobní stránky a menší firemní weby je ideální. Při růstu lze přejít na NoLimit.' },
          { q: 'Jak uplatním slevu?', a: 'Při objednávce vložte kód do košíku a potvrďte. Sleva se ihned projeví.' },
          { q: 'Je migrace webu složitá?', a: 'Většina CMS má jednoduchý postup. V případě potřeby Vám poradí podpora.' }
        ],
        domains: [
          { q: 'Na jaké koncovky sleva platí?', a: 'Sleva 50 % platí pro domény .EU, .ONLINE, .STORE, .TECH, .SITE, .WEBSITE, .SPACE a .FUN.' },
          { q: 'Platí sleva i na prodloužení?', a: 'Akční cena se vztahuje na první rok registrace domény.' },
          { q: 'Jak dlouho trvá registrace?', a: 'Registrace probíhá automaticky po spárování platby, většinou během několika minut.' }
        ],
        vps: [
          { q: 'Proč zvolit VPS místo hostingu?', a: 'Získáte plnou kontrolu nad serverem (root), izolované prostředí a škálování parametrů.' },
          { q: 'Jaké technologie jsou podporovány?', a: 'Libovolná linuxová distribuce, databáze, Docker a další – dle Vaší konfigurace.' },
          { q: 'Je výkon garantovaný?', a: 'Parametry si volíte sami. Infrastruktura je postavená na OpenNebula s SSD úložištěm.' }
        ],
        website: [
          { q: 'Musím umět programovat?', a: 'Ne, stačí vybrat šablonu a upravit obsah v editoru. Publikace je na pár kliknutí.' },
          { q: 'Hodí se pro malé firmy?', a: 'Ano, je to rychlé a cenově dostupné řešení pro prezentaci služeb i kontaktů.' },
          { q: 'Mohu později přejít na hosting?', a: 'Ano, až budete potřebovat větší flexibilitu, lze zvolit NoLimit a vlastní CMS.' }
        ],
        disk: [
          { q: 'Na co je Disk vhodný?', a: 'Na zálohy, archivaci a sdílení dat mimo vlastní infrastrukturu s různými protokoly přístupu.' },
          { q: 'Je přenos dat zabezpečený?', a: 'Ano, využívají se zabezpečené protokoly a přístupy dle zvoleného způsobu připojení.' },
          { q: 'Jak vyberu kapacitu?', a: 'Začněte menším tarifem a dle potřeby jej navyšujte. Sleva sníží počáteční náklady.' }
        ],
        mailhosting: [
          { q: 'Podporujete vlastní doménu?', a: 'Ano, e‑maily běží na Vaší doméně, což působí profesionálně a důvěryhodně.' },
          { q: 'Je k dispozici antispam?', a: 'Ano, součástí je antispamová a antivirová ochrana a moderní webmail.' },
          { q: 'Kolik schránek mohu mít?', a: 'Počet schránek lze snadno rozšiřovat podle potřeb týmu nebo firmy.' }
        ],
        renewal: [
          { q: 'Na jaké služby sleva platí?', a: 'Na prodloužení stávajících služeb dle aktuálních podmínek akce.' },
          { q: 'Lze slevu kombinovat?', a: 'Záleží na pravidlech konkrétní akce. Sledujte newsletter pro detaily.' },
          { q: 'Je kód časově omezen?', a: 'Ano, platnost je vždy uvedena u kupónu. Doporučujeme objednat včas.' }
        ]
      }
    }
  },
  en: {
    title: 'Current Discount Coupons for Vedos.cz',
    subtitle: 'Use current discount coupons and save on web hosting, domains, and other services.',
    cta: 'Go to Vedos.cz',
    homeTitle: 'Vedos Discount Coupons 2026 - Up to 70% off Webhosting, VPS ON, VPS SSD and Domains',
    skipToContent: 'Skip to main content',
    privacyPolicy: 'Privacy Policy',
    discountCode: 'Discount code',
    validUntil: 'valid until',
    topCoupons: 'Top Discount Codes',
    moreInfo: 'More information',
    recommended: 'Recommended',
    site: {
      title: 'slevy-hosting-domeny.cz'
    },
    footer: {
      aboutTitle: 'About project',
      aboutText1: 'collects current discount codes for Vedos.cz services (webhosting, WordPress hosting, VPS, domains and more).',
      aboutText2: 'This website is for informational purposes only and may contain affiliate links. By clicking a link, you support the project; nothing changes for you.',
      linksTitle: 'Links',
      links: {
        home: 'Home',
        blog: 'Blog',
        privacy: 'Privacy Policy'
      },
      servicesTitle: 'Other services',
      services: {
        vinInfo: 'VIN Info.cz — vehicle check',
        fixweb: 'FixWeb.cz — website fixes',
        dealora: 'Dealora.cz — discount codes',
        openShops: 'Are shops open?',
        kurzyKaret: 'KurzyKaret.cz — card payment exchange rates'
      }
    },
    blog: {
      title: 'Blog',
      subtitle: 'Practical guides, comparisons, and tips for choosing hosting, WordPress, VPS, and domains.',
      pageTitle: 'Blog | slevy-hosting-domeny.cz',
      readMore: 'Read article',
      openOffer: 'Open offer',
      relatedOffers: 'Related offers',
      published: 'Published',
      updated: 'Updated',
      minutes: 'min read',
      lessThanMinute: '< 1 min read',
      backToBlog: 'Back to blog',
      noPostsForLanguage: 'No posts are currently available for this language.',
      csOnlyShort: 'Czech content',
      csOnlyNotice: 'This article is currently available only in Czech.',
      languageMismatchNotice: 'This article is available in another language. The original version is shown below.',
      notFoundTitle: 'Article not found',
      notFoundText: 'Try selecting one of the posts in the blog.'
    },
    coupons: {
      webhostingNoLimit: 'Webhosting NoLimit and Extra 70% discount',
      webhostingLowCost: 'Webhosting LowCost, NoLimit and Extra 60% discount',
      domains: '50% discount on domains (.EU, .ONLINE, .STORE, .TECH, .SITE, .WEBSITE, .SPACE, .FUN)',
      vpsOn: 'VPS ON 33% discount',
      vpsSsd: 'VPS SSD 25% discount',
      wordpressHosting: 'WordPress hosting (WP LowCost + WP NoLimit) 50% discount',
      website: 'VEDOS WebSite 50% discount',
      // cd: 'VEDOS CD 25% discount',
      disk: 'VEDOS Disk 25% discount',
      mailhosting: 'Mailhosting 50% discount',
      renewal: 'RENEWAL Discount',
      renewalInfo: {
        text: '(max. 300x). Alternatively, check the',
        linkText: 'current newsletter',
        linkUrl: 'https://www.vedos.cz/en/newsletter?ap=Lf2pCY'
      },
      allCodes: 'Available Discount Codes'
    },
    services: {
      webhostingNoLimit: {
        title: 'Webhosting NoLimit',
        content: 'The most popular and best-selling web hosting in the Czech Republic, ideal for WordPress, e-shops, and demanding projects. Unlimited space, stable performance, and 24/7 support.',
        cta: 'Order with 70% discount'
      },
      webhostingLowCost: {
        title: 'Webhosting LowCost and NoLimit',
        content: '60% discount on Webhosting LowCost and NoLimit - perfect solution for small and large projects.',
        cta: 'Order with 60% discount'
      },
      domains: {
        title: 'Domains',
        content: '50% discount on domains .EU, .ONLINE, .STORE, .TECH, .SITE, .WEBSITE, .SPACE and .FUN. Register your domain at a great price!',
        cta: 'Register with 50% discount'
      },
      vpsOn: {
        title: 'VPS ON',
        content: 'Virtual servers on OpenNebula cloud infrastructure. Pay only for what you need! Choose your RAM, disk space (100% SSD), and number of CPU cores.',
        cta: 'Get VPS ON with 33% discount'
      },
      vpsSsd: {
        title: 'VPS SSD',
        content: 'Powerful virtual servers with dedicated performance and SSD disks. Guaranteed performance and availability for your projects.',
        cta: 'Get VPS SSD with 25% discount'
      },
      wordpressHosting: {
        title: 'WordPress hosting',
        content: 'Special 50% discount on WP LowCost and WP NoLimit WordPress hosting. Great for fast, secure, and reliable WordPress websites.',
        cta: 'Get WordPress hosting with 50% discount'
      },
      website: {
        title: 'VEDOS WebSite',
        content: 'Create your own website easily and quickly. Now with 50% discount on VEDOS WebSite service.',
        cta: 'Create website with 50% discount'
      },
      // cd: {
      //   title: 'VEDOS CD',
      //   content: 'Cloud storage for your data. Get 25% discount on VEDOS CD services.',
      //   cta: 'Activate with 25% discount'
      // },
      disk: {
        title: 'VEDOS Disk',
        content: 'Secure backup storage for your data. Raw disk space with FTP, rsync, SMB, SVN, and Git access. From 30 GB to TB multiples.',
        cta: 'Get with 25% discount'
      },
      mailhosting: {
        title: 'Mailhosting',
        content: 'Modern email on your own domain with Czech support. Stable and secure service with data stored exclusively in Czech Republic datacenter.',
        cta: 'Get mailhosting with 50% discount'
      },
      renewal: {
        title: 'Service Renewal',
        content: 'Special discount on existing service renewals (max. 300x).',
        cta: 'Renew services'
      }
    },
    seo: {
      useCode: 'Use our exclusive discount code',
      saveOnServices: 'and save on Vedos.cz services. This coupon is valid until',
      significantDiscount: 'and provides a significant discount on',
      aboutVedos: 'Vedos.cz is one of the leading providers of web hosting and domain services in the Czech Republic. Our discount coupons allow you to get quality services at great prices.',
      howToUse: 'How to use the discount code',
      step1: 'Click the button',
      step2: 'Select the desired service or package',
      step3: 'Enter the discount code in the cart:',
      step4: 'Complete the order with the applied discount',
      whyChoose: 'Why choose Vedos.cz',
      reason1: 'More than 15 years of market experience',
      reason2: 'Reliable services with high availability',
      reason3: 'Czech technical support',
      reason4: 'Competitive prices',
      reason5: 'Modern technology and infrastructure',
      moreCoupons: 'More discount coupons',
      exploreMore: 'Explore other available discounts on Vedos.cz services',
      allCoupons: 'All coupons',
      above: 'above',
      faqTitle: 'Frequently Asked Questions',
      long: {
        webhostingNoLimit: 'Webhosting NoLimit is a balanced choice for projects that need stable performance, unlimited space and great value. It easily handles WordPress, WooCommerce and most popular CMS platforms.\n\nWith recurring promotions, it belongs to the most cost‑effective options on the market. Migration is straightforward and most sites can be launched within minutes.',
        webhostingLowCost: 'LowCost and NoLimit cover the needs of most websites. LowCost is perfect for personal sites, blogs and small business pages. If you expect growth, consider NoLimit with stronger database and PHP parameters.\n\nDiscount codes usually reduce the setup fee and the first billing period so you save right from the start.',
        vpsOn: 'VPS ON gives you full control – choose CPU, RAM and SSD storage on reliable OpenNebula infrastructure. It suits apps that require root access, isolation and the ability to scale.\n\nThe discount helps you validate production‑like environments at a lower cost and scale later.',
        vpsSsd: 'VPS SSD offers a balanced price-performance ratio with guaranteed parameters within modules. It is ideal for projects requiring a stable and predictable environment. Thanks to SSD disks, operations are very fast.\n\nThe discount applies to service setup and allows you to start with a professional virtual server at minimal cost.',
        wordpressHosting: 'WP LowCost and WP NoLimit WordPress hosting are built specifically for WordPress performance and simplicity. With a 50% discount, you can launch blogs, business sites, and WooCommerce projects at low cost.\n\nThe environment is optimized for modern WordPress, with stable performance and easy administration.',
        domains: 'Domain registration is the first step to your own website. With our discount, you can get popular extensions like .EU, .ONLINE or .STORE at a fraction of the regular price. The promotional price applies to the first year of registration.\n\nIn addition, you get basic DNS management with every domain and the possibility of easy connection with other Vedos services.',
        website: 'VEDOS WebSite lets you build a website without coding. Pick a template, edit content and publish. It is ideal for freelancers and small businesses who want to get online quickly.\n\nThe promo makes professional‑looking websites very affordable compared to custom development.',
        disk: 'VEDOS Disk is secure remote storage for backups and archives. Access via FTP, rsync, SMB, SVN or Git integrates easily with your workflows. Suitable for companies and individuals who need reliable space outside their own infrastructure.\n\nThe coupon reduces the total cost of long‑term data retention.',
        mailhosting: 'Mailhosting on your own domain improves your professional image. You get modern webmail, anti‑virus and anti‑spam protection, with data stored in the Czech Republic. It is easy to add mailboxes and configure aliases.\n\nWith the discount, you can set up company email quickly and affordably.',
        renewal: 'Renewal discounts reduce costs while keeping your current service parameters. Great for long‑running projects that benefit from stability and uninterrupted operation. Watch the newsletter – it often includes generous renewal codes.'
      },
      faqs: {
        webhostingNoLimit: [
          { q: 'Who is NoLimit for?', a: 'For business sites, blogs, magazines and small e‑shops on WordPress, with ample performance and unlimited space.' },
          { q: 'Can I upgrade from LowCost?', a: 'Yes, you can upgrade anytime without service downtime.' },
          { q: 'Is HTTPS and backup available?', a: 'Yes, Let’s Encrypt/SSL and regular backups are available per service policy.' }
        ],
        webhostingLowCost: [
          { q: 'Is LowCost enough for a small site?', a: 'Yes, it suits personal and small business sites. You can upgrade to NoLimit later.' },
          { q: 'How do I apply the coupon?', a: 'Enter the code in the checkout and confirm; the price updates immediately.' },
          { q: 'Is migration difficult?', a: 'Most CMS platforms have simple migration steps. Support can help if needed.' }
        ],
        domains: [
          { q: 'Which extensions is the discount for?', a: 'The 50% discount applies to .EU, .ONLINE, .STORE, .TECH, .SITE, .WEBSITE, .SPACE, and .FUN domains.' },
          { q: 'Does the discount apply to renewal?', a: 'The promotional price applies to the first year of domain registration.' },
          { q: 'How long does registration take?', a: 'Registration is automatic after payment matching, usually within minutes.' }
        ],
        vps: [
          { q: 'Why choose VPS over shared hosting?', a: 'You get full root control, isolated environment and scalable resources.' },
          { q: 'What technologies can I run?', a: 'Any Linux distro, databases, Docker and more – according to your setup.' },
          { q: 'Is performance guaranteed?', a: 'You select the parameters. The platform runs on OpenNebula with SSD storage.' }
        ],
        website: [
          { q: 'Do I need to code?', a: 'No, choose a template and edit content in an editor. Publish in minutes.' },
          { q: 'Is it good for small businesses?', a: 'Yes, a quick and budget‑friendly way to present your services and contacts.' },
          { q: 'Can I switch to hosting later?', a: 'Yes, move to NoLimit and your own CMS when you need more flexibility.' }
        ],
        disk: [
          { q: 'What is Disk good for?', a: 'Backups, archiving and sharing data outside your infrastructure with multiple access protocols.' },
          { q: 'Is data transfer secure?', a: 'Yes, secure protocols and access methods are available depending on configuration.' },
          { q: 'How to choose capacity?', a: 'Start smaller and scale as needed. The discount lowers initial costs.' }
        ],
        mailhosting: [
          { q: 'Do you support my own domain?', a: 'Yes, email runs on your domain for a professional, trustworthy presence.' },
          { q: 'Is anti‑spam included?', a: 'Yes, anti‑spam and anti‑virus protection with modern webmail are included.' },
          { q: 'How many mailboxes can I have?', a: 'You can easily add more mailboxes as your team grows.' }
        ],
        renewal: [
          { q: 'Which services does it apply to?', a: 'Renewals of existing services according to current promo rules.' },
          { q: 'Can I combine discounts?', a: 'Depends on the campaign rules. Check the newsletter for details.' },
          { q: 'Is the code time‑limited?', a: 'Yes, validity is always stated with the coupon. Order in time.' }
        ]
      }
    }
  },
  pl: {
    title: 'Aktualne kupony rabatowe na Vedos.cz',
    subtitle: 'Skorzystaj z aktualnych kuponów rabatowych i zaoszczędź na hostingu, domenach i innych usługach.',
    cta: 'Przejdź do Vedos.cz',
    homeTitle: 'Kupony rabatowe Vedos 2026 - Do 70% zniżki na Webhosting, VPS ON, VPS SSD i Domeny',
    skipToContent: 'Przejdź do treści',
    privacyPolicy: 'Polityka prywatności',
    discountCode: 'Kod rabatowy',
    validUntil: 'ważny do',
    topCoupons: 'Najlepsze Kody Rabatowe',
    moreInfo: 'Więcej informacji',
    recommended: 'Polecane',
    site: {
      title: 'slevy-hosting-domeny.cz'
    },
    footer: {
      aboutTitle: 'O projekcie',
      aboutText1: 'zbiera aktualne kody rabatowe na usługi Vedos.cz (webhosting, WordPress hosting, VPS, domeny i inne).',
      aboutText2: 'Ta strona ma charakter informacyjny i może zawierać linki afiliacyjne. Klikając link, wspierasz projekt — dla Ciebie nic się nie zmienia.',
      linksTitle: 'Linki',
      links: {
        home: 'Strona główna',
        blog: 'Blog',
        privacy: 'Polityka prywatności'
      },
      servicesTitle: 'Inne usługi',
      services: {
        vinInfo: 'VIN Info.cz — sprawdzenie pojazdu',
        fixweb: 'FixWeb.cz — naprawy stron',
        dealora: 'Dealora.cz — kody rabatowe',
        openShops: 'Czy sklepy są otwarte?',
        kurzyKaret: 'KurzyKaret.cz — kursy przy płatności kartą'
      }
    },
    blog: {
      title: 'Blog',
      subtitle: 'Praktyczne poradniki, porównania i wskazówki dotyczące hostingu, WordPressa, VPS i domen.',
      pageTitle: 'Blog | slevy-hosting-domeny.cz',
      readMore: 'Czytaj artykuł',
      openOffer: 'Otwórz ofertę',
      relatedOffers: 'Powiązane oferty',
      published: 'Opublikowano',
      updated: 'Zaktualizowano',
      minutes: 'min czytania',
      lessThanMinute: '< 1 min czytania',
      backToBlog: 'Powrót do bloga',
      noPostsForLanguage: 'Dla tego języka nie ma jeszcze dostępnych artykułów.',
      csOnlyShort: 'Treść po czesku',
      csOnlyNotice: 'Ten artykuł jest obecnie dostępny tylko po czesku.',
      languageMismatchNotice: 'Ten artykuł jest dostępny w innym języku. Poniżej widzisz oryginalną wersję.',
      notFoundTitle: 'Nie znaleziono artykułu',
      notFoundText: 'Wybierz jeden z artykułów na blogu.'
    },
    coupons: {
      webhostingNoLimit: 'Webhosting NoLimit i dodatkowy rabat 70%',
      webhostingLowCost: 'Webhosting LowCost, NoLimit i dodatkowy rabat 60%',
      domains: '50% rabatu na domeny (.EU, .ONLINE, .STORE, .TECH, .SITE, .WEBSITE, .SPACE, .FUN)',
      vpsOn: 'VPS ON rabat 33%',
      vpsSsd: 'VPS SSD rabat 25%',
      wordpressHosting: 'WordPress hosting (WP LowCost + WP NoLimit) rabat 50%',
      website: 'VEDOS WebSite rabat 50%',
      // cd: 'VEDOS CD rabat 25%',
      disk: 'VEDOS Disk rabat 25%',
      mailhosting: 'Mailhosting rabat 50%',
      renewal: 'Rabat na PRZEDŁUŻENIE',
      renewalInfo: {
        text: '(maks. 300x). Ewentualnie sprawdź w',
        linkText: 'aktualnym newsletterze',
        linkUrl: 'https://www.vedos.cz/newsletter?ap=Lf2pCY'
      },
      allCodes: 'Dostępne Kody Rabatowe'
    },
    services: {
      webhostingNoLimit: {
        title: 'Webhosting NoLimit',
        content: 'Najpopularniejszy i najlepiej sprzedający się hosting w Czechach, idealny dla WordPress, e-sklepów i wymagających projektów. Nieograniczona przestrzeń, stabilna wydajność i wsparcie 24/7.',
        cta: 'Zamów z 70% rabatem'
      },
      webhostingLowCost: {
        title: 'Webhosting LowCost i NoLimit',
        content: '60% zniżki na Webhosting LowCost i NoLimit - idealne rozwiązanie dla małych i dużych projektów.',
        cta: 'Zamów z 60% rabatem'
      },
      domains: {
        title: 'Domeny',
        content: '50% zniżki na domeny .EU, .ONLINE, .STORE, .TECH, .SITE, .WEBSITE, .SPACE i .FUN. Zarejestruj swoją domenę w korzystnej cenie!',
        cta: 'Zarejestruj z 50% rabatem'
      },
      vpsOn: {
        title: 'VPS ON',
        content: 'Serwery wirtualne na infrastrukturze chmurowej OpenNebula. Płać tylko za to, czego potrzebujesz! Wybierz RAM, przestrzeń dyskową (100% SSD) i liczbę rdzeni CPU.',
        cta: 'Uzyskaj VPS ON z 33% rabatem'
      },
      vpsSsd: {
        title: 'VPS SSD',
        content: 'Wydajne serwery wirtualne z dedykowaną wydajnością i dyskami SSD. Gwarantowana wydajność i dostępność dla Twoich projektów.',
        cta: 'Uzyskaj VPS SSD z 25% rabatem'
      },
      wordpressHosting: {
        title: 'WordPress hosting',
        content: 'Specjalna zniżka 50% na WordPress hosting WP LowCost i WP NoLimit. Idealny wybór dla szybkich i bezpiecznych stron WordPress.',
        cta: 'Uzyskaj WordPress hosting z 50% rabatem'
      },
      website: {
        title: 'VEDOS WebSite',
        content: 'Stwórz własną stronę internetową łatwo i szybko. Teraz 50% zniżki na usługę VEDOS WebSite.',
        cta: 'Stwórz stronę z 50% rabatem'
      },
      // cd: {
      //   title: 'VEDOS CD',
      //   content: 'Przechowywanie w chmurze dla Twoich danych. Skorzystaj z 25% zniżki na usługi VEDOS CD.',
      //   cta: 'Aktywuj z 25% rabatem'
      // },
      disk: {
        title: 'VEDOS Disk',
        content: 'Bezpieczne magazynowanie kopii zapasowych dla Twoich danych. Surowa przestrzeń dyskowa z dostępem przez FTP, rsync, SMB, SVN i Git. Od 30 GB do wielokrotności TB.',
        cta: 'Uzyskaj z 25% rabatem'
      },
      mailhosting: {
        title: 'Mailhosting',
        content: 'Nowoczesny e-mail na własnej domenie z czeskim wsparciem. Stabilna i bezpieczna usługa z danymi przechowywanymi wyłącznie w centrum danych w Czechach.',
        cta: 'Uzyskaj mailhosting z 50% rabatem'
      },
      renewal: {
        title: 'Przedłużenie usług',
        content: 'Specjalna zniżka na przedłużenie istniejących usług (maks. 300x).',
        cta: 'Przedłuż usługi'
      }
    },
    seo: {
      useCode: 'Skorzystaj z naszego ekskluzywnego kodu rabatowego',
      saveOnServices: 'i zaoszczędź na usługach Vedos.cz. Ten kupon jest ważny do',
      significantDiscount: 'i zapewnia znaczną zniżkę na',
      aboutVedos: 'Vedos.cz to jeden z wiodących dostawców hostingu i usług domenowych w Czechach. Nasze kupony rabatowe pozwalają uzyskać wysokiej jakości usługi w świetnych cenach.',
      howToUse: 'Jak użyć kodu rabatowego',
      step1: 'Kliknij przycisk',
      step2: 'Wybierz żądaną usługę lub pakiet',
      step3: 'Wprowadź kod rabatowy w koszyku:',
      step4: 'Dokończ zamówienie z zastosowaną zniżką',
      whyChoose: 'Dlaczego wybrać Vedos.cz',
      reason1: 'Ponad 15 lat doświadczenia na rynku',
      reason2: 'Niezawodne usługi o wysokiej dostępności',
      reason3: 'Czeska obsługa techniczna',
      reason4: 'Konkurencyjne ceny',
      reason5: 'Nowoczesna technologia i infrastruktura',
      moreCoupons: 'Więcej kuponów rabatowych',
      exploreMore: 'Poznaj inne dostępne zniżki na usługi Vedos.cz',
      allCoupons: 'Wszystkie kupony',
      above: 'powyżej',
      faqTitle: 'Najczęściej zadawane pytania',
      long: {
        webhostingNoLimit: 'Webhosting NoLimit to stabilne i opłacalne rozwiązanie dla WordPressa, WooCommerce i popularnych CMS‑ów. Oferuje nielimitowaną przestrzeń i dobrą wydajność w rozsądnej cenie.\n\nDzięki promocjom jest to jedna z najkorzystniejszych ofert. Migracja strony zwykle zajmuje kilka minut.',
        webhostingLowCost: 'LowCost i NoLimit pokrywają potrzeby większości stron. LowCost jest świetny na start dla blogów i małych firm. Przy wzroście ruchu warto rozważyć NoLimit z lepszymi parametrami.\n\nKody rabatowe obniżają koszt uruchomienia oraz pierwszego okresu rozliczeniowego.',
        vpsOn: 'VPS ON daje pełną kontrolę – CPU, RAM i dysk SSD w oparciu o OpenNebula. Idealny dla aplikacji wymagających dostępu root, izolacji i skalowania.\n\nZniżka pozwala taniej przetestować środowisko produkcyjne.',
        vpsSsd: 'VPS SSD oferuje zrównoważony stosunek ceny do wydajności z gwarantowanymi parametrami w ramach modułów. Idealny dla projektów wymagających stabilnego i przewidywalnego środowiska. Dzięki dyskom SSD operacje są bardzo szybkie.\n\nZniżka dotyczy konfiguracji usługi i pozwala rozpocząć pracę z profesjonalnym serwerem wirtualnym przy minimalnych kosztach.',
        wordpressHosting: 'WordPress hosting WP LowCost i WP NoLimit jest przygotowany specjalnie pod wydajność WordPressa. Dzięki zniżce 50% możesz tanio uruchomić blog, stronę firmową lub sklep WooCommerce.\n\nŚrodowisko jest zoptymalizowane pod nowoczesnego WordPressa i zapewnia prostą administrację.',
        website: 'VEDOS WebSite umożliwia stworzenie strony bez programowania. Wybierz szablon, edytuj treść i opublikuj. Rozwiązanie idealne dla jednoosobowych firm i małych biznesów.\n\nPromocja znacząco obniża koszt profesjonalnie wyglądającej witryny.',
        disk: 'VEDOS Disk to bezpieczna pamięć masowa na kopie zapasowe i archiwum. Dostęp przez FTP, rsync, SMB, SVN, Git ułatwia integrację z procesami.\n\nKupon obniża koszt długoterminowej retencji danych.',
        mailhosting: 'Mailhosting na własnej domenie wzmacnia wizerunek firmy. Nowoczesny webmail i ochrona antyspamowa/antywirusowa, dane w centrum danych w Czechach.\n\nDzięki zniżce szybko i tanio uruchomisz pocztę firmową.',
        renewal: 'Zniżka na przedłużenie obniża koszty przy zachowaniu bieżących parametrów usług. Dobre dla projektów długoterminowych. Warto śledzić newsletter z kodami.'
      },
      faqs: {
        webhostingNoLimit: [
          { q: 'Dla kogo jest NoLimit?', a: 'Dla firmowych stron, blogów, magazynów i małych sklepów na WordPressie.' },
          { q: 'Czy mogę przejść z LowCost?', a: 'Tak, aktualizacja jest możliwa w dowolnym momencie bez przestoju.' },
          { q: 'Czy jest HTTPS i kopie zapasowe?', a: 'Tak, Let’s Encrypt/SSL i regularne backupy zgodnie z polityką usługi.' }
        ],
        webhostingLowCost: [
          { q: 'Czy LowCost wystarczy na małą stronę?', a: 'Tak, a w razie potrzeby można przejść na NoLimit.' },
          { q: 'Jak użyć kodu rabatowego?', a: 'Wpisz kod w koszyku i potwierdź – cena zaktualizuje się od razu.' },
          { q: 'Czy migracja jest trudna?', a: 'Większość CMS‑ów ma prostą procedurę. W razie potrzeby pomoże wsparcie.' }
        ],
        domains: [
          { q: 'Na jakie rozszerzenia obowiązuje zniżka?', a: 'Zniżka 50% dotyczy domen .EU, .ONLINE, .STORE, .TECH, .SITE, .WEBSITE, .SPACE i .FUN.' },
          { q: 'Czy zniżka dotyczy również przedłużenia?', a: 'Cena promocyjna dotyczy pierwszego roku rejestracji domeny.' },
          { q: 'Jak długo trwa rejestracja?', a: 'Rejestracja odbywa się automatycznie po zaksięgowaniu wpłaty, zwykle w ciągu kilku minut.' }
        ],
        vps: [
          { q: 'Dlaczego VPS zamiast hostingu?', a: 'Pełna kontrola (root), izolacja i skalowalne zasoby.' },
          { q: 'Jakie technologie są wspierane?', a: 'Dowolne dystrybucje Linuksa, bazy danych, Docker i inne.' },
          { q: 'Czy wydajność jest gwarantowana?', a: 'Parametry wybierasz sam. Platforma działa na OpenNebula z dyskami SSD.' }
        ],
        website: [
          { q: 'Czy muszę programować?', a: 'Nie, wybierz szablon i edytuj treść w edytorze. Publikacja w kilka minut.' },
          { q: 'Czy nadaje się dla małych firm?', a: 'Tak, szybkie i budżetowe rozwiązanie do prezentacji usług.' },
          { q: 'Czy mogę później przejść na hosting?', a: 'Tak, przy większych wymaganiach wybierz NoLimit i własny CMS.' }
        ],
        disk: [
          { q: 'Do czego służy Disk?', a: 'Kopie zapasowe, archiwizacja i udostępnianie danych z różnymi protokołami dostępu.' },
          { q: 'Czy transfer jest bezpieczny?', a: 'Tak, dostępne są bezpieczne protokoły i metody dostępu.' },
          { q: 'Jak dobrać pojemność?', a: 'Zacznij od mniejszego planu i zwiększaj w razie potrzeby.' }
        ],
        mailhosting: [
          { q: 'Czy obsługujecie własną domenę?', a: 'Tak, poczta działa na Twojej domenie – profesjonalnie i wiarygodnie.' },
          { q: 'Czy jest antyspam?', a: 'Tak, dostępna jest ochrona antyspamowa i antywirusowa oraz nowoczesny webmail.' },
          { q: 'Ile skrzynek mogę mieć?', a: 'Liczbę skrzynek można łatwo zwiększać wraz z rozwojem zespołu.' }
        ],
        renewal: [
          { q: 'Jakie usługi obejmuje zniżka?', a: 'Przedłużenia istniejących usług zgodnie z zasadami promocji.' },
          { q: 'Czy można łączyć zniżki?', a: 'Zależy od kampanii – szczegóły w newsletterze.' },
          { q: 'Czy kod jest ograniczony czasowo?', a: 'Tak, ważność jest podana przy kuponie. Zamów w odpowiednim czasie.' }
        ]
      }
    }
  },
  sk: {
    title: 'Aktuálne zľavové kupóny na Vedos.cz',
    subtitle: 'Využite aktuálne zľavové kupóny a ušetrite na webhostingu, doménach a ďalších službách.',
    cta: 'Prejsť na Vedos.cz',
    homeTitle: 'Vedos Zľavové Kupóny 2026 - Až 70% Zľava na Webhosting, VPS ON, VPS SSD a Domény',
    skipToContent: 'Preskočiť na obsah',
    privacyPolicy: 'Ochrana osobných údajov',
    discountCode: 'Zľavový kód',
    validUntil: 'platný do',
    topCoupons: 'Top Zľavové Kódy',
    moreInfo: 'Viac informácií',
    recommended: 'Odporúčané',
    site: {
      title: 'slevy-hosting-domeny.cz'
    },
    footer: {
      aboutTitle: 'O projekte',
      aboutText1: 'zhromažďuje aktuálne zľavové kódy na služby Vedos.cz (webhosting, WordPress hosting, VPS, domény a ďalšie).',
      aboutText2: 'Web je informatívny a môže obsahovať affiliate odkazy. Kliknutím na odkaz podporíte projekt, pre vás sa nič nemení.',
      linksTitle: 'Odkazy',
      links: {
        home: 'Domov',
        blog: 'Blog',
        privacy: 'Ochrana osobných údajov'
      },
      servicesTitle: 'Ďalšie služby',
      services: {
        vinInfo: 'VIN Info.cz — kontrola vozidla',
        fixweb: 'FixWeb.cz — opravy webov',
        dealora: 'Dealora.cz — zľavové kódy',
        openShops: 'Sú obchody otvorené?',
        kurzyKaret: 'KurzyKaret.cz — kurzy pri platbe kartou'
      }
    },
    blog: {
      title: 'Blog',
      subtitle: 'Praktické návody, porovnania a tipy pre výber hostingu, WordPressu, VPS a domén.',
      pageTitle: 'Blog | slevy-hosting-domeny.cz',
      readMore: 'Čítať článok',
      openOffer: 'Otvoriť ponuku',
      relatedOffers: 'Súvisiace ponuky',
      published: 'Publikované',
      updated: 'Aktualizované',
      minutes: 'min čítania',
      lessThanMinute: '< 1 min čítania',
      backToBlog: 'Späť na blog',
      noPostsForLanguage: 'Pre tento jazyk zatiaľ nie sú dostupné články.',
      csOnlyShort: 'Obsah v češtine',
      csOnlyNotice: 'Tento článok je aktuálne dostupný iba v češtine.',
      languageMismatchNotice: 'Tento článok je dostupný v inom jazyku. Nižšie vidíte pôvodnú verziu.',
      notFoundTitle: 'Článok sa nenašiel',
      notFoundText: 'Vyberte si niektorý z článkov na blogu.'
    },
    coupons: {
      webhostingNoLimit: 'Webhosting NoLimit a Extra zľava 70 %',
      webhostingLowCost: 'Webhosting LowCost, NoLimit a Extra zľava 60 %',
      domains: '50% zľava na domény (.EU, .ONLINE, .STORE, .TECH, .SITE, .WEBSITE, .SPACE, .FUN)',
      vpsOn: 'VPS ON zľava 33 %',
      vpsSsd: 'VPS SSD zľava 25 %',
      wordpressHosting: 'WordPress hosting (WP LowCost + WP NoLimit) zľava 50 %',
      website: 'VEDOS WebSite zľava 50 %',
      // cd: 'VEDOS CD zľava 25 %',
      disk: 'VEDOS Disk zľava 25 %',
      mailhosting: 'Mailhosting zľava 50 %',
      renewal: 'Zľava na PREDĹŽENIE',
      renewalInfo: {
        text: '(max. 300x). Prípadne skúste nájsť v',
        linkText: 'aktuálnom newsletteri',
        linkUrl: 'https://www.vedos.cz/sk/newsletter?ap=Lf2pCY'
      },
      allCodes: 'Dostupné Zľavové Kódy'
    },
    services: {
      webhostingNoLimit: {
        title: 'Webhosting NoLimit',
        content: 'Najpopulárnejší a najpredávanejší webhosting v Českej republike, ideálny pre WordPress, e-shopy a náročné projekty. Neobmedzený priestor, stabilný výkon a nonstop podpora.',
        cta: 'Objednať so zľavou 70%'
      },
      webhostingLowCost: {
        title: 'Webhosting LowCost a NoLimit',
        content: '60% zľava na Webhosting LowCost a NoLimit - ideálne riešenie pre menšie aj väčšie projekty.',
        cta: 'Objednať so zľavou 60%'
      },
      domains: {
        title: 'Domény',
        content: '50% zľava na domény .EU, .ONLINE, .STORE, .TECH, .SITE, .WEBSITE, .SPACE a .FUN. Zaregistrujte si svoju doménu výhodne!',
        cta: 'Registrovať so zľavou 50%'
      },
      vpsOn: {
        title: 'VPS ON',
        content: 'Virtuálne servery na cloudovej infraštruktúre OpenNebula. Plaťte len za to, čo potrebujete! Zvoľte si RAM, diskový priestor (100% SSD) a počet CPU jadier.',
        cta: 'Získať VPS ON so zľavou 33%'
      },
      vpsSsd: {
        title: 'VPS SSD',
        content: 'Výkonné virtuálne servery s vyhradeným výkonom a SSD diskami. Garantovaný výkon a dostupnosť pre vaše projekty.',
        cta: 'Získať VPS SSD so zľavou 25%'
      },
      wordpressHosting: {
        title: 'WordPress hosting',
        content: 'Špeciálna 50% zľava na WordPress hosting WP LowCost a WP NoLimit. Ideálne riešenie pre rýchle a bezpečné WordPress weby.',
        cta: 'Získať WordPress hosting so zľavou 50%'
      },
      website: {
        title: 'VEDOS WebSite',
        content: 'Vytvorte si vlastnú webstránku jednoducho a rýchlo. Teraz s 50% zľavou na službu VEDOS WebSite.',
        cta: 'Vytvoriť web so zľavou 50%'
      },
      // cd: {
      //   title: 'VEDOS CD',
      //   content: 'Cloudové úložisko pre vaše dáta. Využite 25% zľavu na služby VEDOS CD.',
      //   cta: 'Aktivovať so zľavou 25%'
      // },
      disk: {
        title: 'VEDOS Disk',
        content: 'Bezpečné záložné úložisko pre vaše dáta. Holý diskový priestor s prístupom cez FTP, rsync, SMB, SVN a Git. Od 30 GB do násobkov TB.',
        cta: 'Získať so zľavou 25%'
      },
      mailhosting: {
        title: 'Mailhosting',
        content: 'Moderný e-mail na vlastnej doméne s českou podporou. Stabilná a bezpečná služba s dátami uloženými výhradne v datacentre v ČR.',
        cta: 'Získať mailhosting so zľavou 50%'
      },
      renewal: {
        title: 'Predĺženie služieb',
        content: 'Špeciálna zľava na predĺženie existujúcich služieb (max. 300x).',
        cta: 'Predĺžiť služby'
      }
    },
    seo: {
      useCode: 'Využite náš exkluzívny zľavový kód',
      saveOnServices: 'a ušetrite na službách Vedos.cz. Tento kupón je platný do',
      significantDiscount: 'a poskytuje významnú zľavu na',
      aboutVedos: 'Vedos.cz je jedným z popredných poskytovateľov webhostingu a doménových služieb v Českej republike. Naše zľavové kupóny vám umožňujú získať kvalitné služby za výhodné ceny.',
      howToUse: 'Ako použiť zľavový kód',
      step1: 'Kliknite na tlačidlo',
      step2: 'Vyberte požadovanú službu alebo balíček',
      step3: 'V košíku zadajte zľavový kód:',
      step4: 'Dokončite objednávku s aplikovanou zľavou',
      whyChoose: 'Prečo vybrať Vedos.cz',
      reason1: 'Viac ako 15 rokov skúseností na trhu',
      reason2: 'Spoľahlivé služby s vysokou dostupnosťou',
      reason3: 'Česká technická podpora',
      reason4: 'Konkurencieschopné ceny',
      reason5: 'Moderné technológie a infraštruktúra',
      moreCoupons: 'Ďalšie zľavové kupóny',
      exploreMore: 'Preskúmajte ďalšie dostupné zľavy na služby Vedos.cz',
      allCoupons: 'Všetky kupóny',
      above: 'vyššie',
      faqTitle: 'Najčastejšie otázky',
      long: {
        webhostingNoLimit: 'Webhosting NoLimit je vyvážená voľba pre WordPress, WooCommerce aj CMS s dôrazom na stabilitu a neobmedzený priestor.\n\nVďaka akciám patrí medzi cenovo najvýhodnejšie riešenia. Migrácia je jednoduchá a rýchla.',
        webhostingLowCost: 'LowCost a NoLimit pokrývajú potreby väčšiny webov. LowCost je skvelý štart pre blogy a menšie firmy, pri raste sa oplatí prejsť na NoLimit s lepšími parametrami.\n\nZľavové kódy obvykle znižujú zriaďovací poplatok aj prvé obdobie.',
        vpsOn: 'VPS ON dáva plnú kontrolu – voľba CPU, RAM a SSD disku na OpenNebula infraštruktúre. Vhodné pre aplikácie vyžadujúce root prístup, izoláciu a škálovanie.\n\nZľava umožní lacnejší test produkčného prostredia.',
        vpsSsd: 'VPS SSD ponúka vyvážený pomer ceny a výkonu s garantovanými parametrami v rámci modulov. Je ideálny pre projekty, ktoré vyžadujú stabilné a predikovateľné prostredie. Vďaka SSD diskom sú operácie veľmi rýchle.\n\nZľava sa vzťahuje na zriadenie služby a umožňuje Vám začať s profesionálnym virtuálnym serverom za minimálne náklady.',
        wordpressHosting: 'WordPress hosting WP LowCost a WP NoLimit je navrhnutý pre rýchly a stabilný chod WordPress webov. So zľavou 50 % môžete výhodne spustiť blog, firemný web aj WooCommerce projekt.\n\nProstredie je optimalizované pre moderný WordPress a jednoduchú správu.',
        website: 'VEDOS WebSite umožní zostaviť web bez programovania. Vyberiete šablónu, upravíte obsah a publikujete. Ideálne pre živnostníkov a malé firmy.\n\nVďaka zľave získate profesionálny web za nízku cenu.',
        disk: 'VEDOS Disk je bezpečné vzdialené úložisko pre zálohy a archív. Prístup cez FTP, rsync, SMB, SVN či Git uľahčuje integráciu do procesov.\n\nKupón znižuje náklady na dlhodobé uloženie dát.',
        mailhosting: 'Mailhosting na vlastnej doméne podporí profesionálny imidž. Moderný webmail, antispam/antivírus a dáta uložené v ČR. Jednoduché rozširovanie počtu schránok.\n\nSo zľavou vybavíte firemný e‑mail rýchlo a výhodne.',
        renewal: 'Zľava na predĺženie znižuje náklady pri zachovaní parametrov. Vhodné pre dlhodobé projekty so zameraním na stabilitu. Sledujte newsletter pre výhodné kódy.'
      },
      faqs: {
        webhostingNoLimit: [
          { q: 'Pre koho je NoLimit?', a: 'Pre firemné weby, blogy, magazíny a menšie e‑shopy na WordPress.' },
          { q: 'Je možný prechod z LowCost?', a: 'Áno, kedykoľvek bez odstávky služby.' },
          { q: 'Je k dispozícii HTTPS a zálohy?', a: 'Áno, Let’s Encrypt/SSL a pravidelné zálohy podľa podmienok služby.' }
        ],
        webhostingLowCost: [
          { q: 'Stačí LowCost pre menší web?', a: 'Áno, a pri raste môžete prejsť na NoLimit.' },
          { q: 'Ako uplatním zľavu?', a: 'Zadajte kód v košíku a potvrďte – cena sa ihneď upraví.' },
          { q: 'Je migrácia zložitá?', a: 'Väčšina CMS má jednoduchý postup. Podpora poradí, ak bude treba.' }
        ],
        domains: [
          { q: 'Na ktoré koncovky zľava platí?', a: 'Zľava 50 % platí pre domény .EU, .ONLINE, .STORE, .TECH, .SITE, .WEBSITE, .SPACE a .FUN.' },
          { q: 'Platí zľava aj na predĺženie?', a: 'Akčná cena sa vzťahuje na prvý rok registrácie domény.' },
          { q: 'Ako dlho trvá registrácia?', a: 'Registrácia prebieha automaticky po spárovaní platby, väčšinou počas niekoľkých minút.' }
        ],
        vps: [
          { q: 'Prečo VPS namiesto hostingu?', a: 'Plná kontrola (root), izolované prostredie a škálovateľné zdroje.' },
          { q: 'Aké technológie môžem používať?', a: 'Ľubovoľné Linux distribúcie, databázy, Docker a ďalšie.' },
          { q: 'Je výkon garantovaný?', a: 'Parametre si volíte sami. Platforma beží na OpenNebula s SSD úložiskom.' }
        ],
        website: [
          { q: 'Musím vedieť programovať?', a: 'Nie, stačí šablóna a editor. Publikácia je otázkou minút.' },
          { q: 'Hodí sa pre malé firmy?', a: 'Áno, rýchle a cenovo dostupné riešenie prezentácie služieb.' },
          { q: 'Môžem neskôr prejsť na hosting?', a: 'Áno, pri väčších požiadavkách zvoľte NoLimit a vlastné CMS.' }
        ],
        disk: [
          { q: 'Na čo je Disk vhodný?', a: 'Na zálohy, archiváciu a zdieľanie dát mimo vlastnej infraštruktúry.' },
          { q: 'Je prenos dát zabezpečený?', a: 'Áno, k dispozícii sú bezpečné protokoly a prístupy.' },
          { q: 'Ako zvoliť kapacitu?', a: 'Začnite menším plánom a podľa potreby ho navyšujte.' }
        ],
        mailhosting: [
          { q: 'Podporujete vlastnú doménu?', a: 'Áno, e‑mail beží na Vašej doméne – profesionálne a dôveryhodne.' },
          { q: 'Je zahrnutý antispam?', a: 'Áno, antispam a antivírus s moderným webmailom.' },
          { q: 'Koľko schránok môžem mať?', a: 'Počet schránok možno jednoducho rozširovať.' }
        ],
        renewal: [
          { q: 'Na ktoré služby platí zľava?', a: 'Na predĺženie existujúcich služieb podľa pravidiel akcie.' },
          { q: 'Dá sa zľava kombinovať?', a: 'Záleží od kampane. Detaily nájdete v newsletteri.' },
          { q: 'Je kód časovo obmedzený?', a: 'Áno, platnosť je uvedená pri kupóne. Objednajte včas.' }
        ]
      }
    }
  },
  de: {
    title: 'Aktuelle Rabatt-Coupons für Vedos.cz',
    subtitle: 'Nutzen Sie aktuelle Rabatt-Coupons und sparen Sie bei Webhosting, Domains und anderen Dienstleistungen.',
    cta: 'Zu Vedos.cz',
    homeTitle: 'Vedos Rabatt-Coupons 2026 - Bis zu 70% Rabatt auf Webhosting, VPS ON, VPS SSD und Domains',
    skipToContent: 'Zum Inhalt springen',
    privacyPolicy: 'Datenschutzerklärung',
    discountCode: 'Rabattcode',
    validUntil: 'gültig bis',
    topCoupons: 'Top Rabattcodes',
    moreInfo: 'Mehr Informationen',
    recommended: 'Empfohlen',
    site: {
      title: 'slevy-hosting-domeny.cz'
    },
    footer: {
      aboutTitle: 'Über das Projekt',
      aboutText1: 'sammelt aktuelle Rabattcodes für Vedos.cz-Dienste (Webhosting, WordPress Hosting, VPS, Domains und mehr).',
      aboutText2: 'Diese Website dient nur zu Informationszwecken und kann Affiliate-Links enthalten. Mit einem Klick auf einen Link unterstützen Sie das Projekt — für Sie ändert sich nichts.',
      linksTitle: 'Links',
      links: {
        home: 'Startseite',
        blog: 'Blog',
        privacy: 'Datenschutzerklärung'
      },
      servicesTitle: 'Weitere Dienste',
      services: {
        vinInfo: 'VIN Info.cz — Fahrzeugprüfung',
        fixweb: 'FixWeb.cz — Webseiten-Reparaturen',
        dealora: 'Dealora.cz — Rabattcodes',
        openShops: 'Sind die Geschäfte geöffnet?',
        kurzyKaret: 'KurzyKaret.cz — Kurse bei Kartenzahlung'
      }
    },
    blog: {
      title: 'Blog',
      subtitle: 'Praktische Anleitungen, Vergleiche und Tipps zur Wahl von Hosting, WordPress, VPS und Domains.',
      pageTitle: 'Blog | slevy-hosting-domeny.cz',
      readMore: 'Artikel lesen',
      openOffer: 'Angebot öffnen',
      relatedOffers: 'Verwandte Angebote',
      published: 'Veröffentlicht',
      updated: 'Aktualisiert',
      minutes: 'Min. Lesezeit',
      lessThanMinute: '< 1 Min. Lesezeit',
      backToBlog: 'Zurück zum Blog',
      noPostsForLanguage: 'Für diese Sprache sind noch keine Artikel verfügbar.',
      csOnlyShort: 'Inhalt auf Tschechisch',
      csOnlyNotice: 'Dieser Artikel ist derzeit nur auf Tschechisch verfügbar.',
      languageMismatchNotice: 'Dieser Artikel ist in einer anderen Sprache verfügbar. Unten sehen Sie die Originalversion.',
      notFoundTitle: 'Artikel nicht gefunden',
      notFoundText: 'Wählen Sie bitte einen der Blogartikel aus.'
    },
    coupons: {
      webhostingNoLimit: 'Webhosting NoLimit und Extra 70% Rabatt',
      webhostingLowCost: 'Webhosting LowCost, NoLimit und Extra 60% Rabatt',
      domains: '50% Rabatt auf Domains (.EU, .ONLINE, .STORE, .TECH, .SITE, .WEBSITE, .SPACE, .FUN)',
      vpsOn: 'VPS ON 33% Rabatt',
      vpsSsd: 'VPS SSD 25% Rabatt',
      wordpressHosting: 'WordPress Hosting (WP LowCost + WP NoLimit) 50% Rabatt',
      website: 'VEDOS WebSite 50% Rabatt',
      // cd: 'VEDOS CD 25% Rabatt',
      disk: 'VEDOS Disk 25% Rabatt',
      mailhosting: 'Mailhosting 50% Rabatt',
      renewal: 'VERLÄNGERUNGS-Rabatt',
      renewalInfo: {
        text: '(max. 300x). Alternativ im',
        linkText: 'aktuellen Newsletter',
        linkUrl: 'https://www.vedos.cz/en/newsletter?ap=Lf2pCY'
      },
      allCodes: 'Verfügbare Rabattcodes'
    },
    services: {
      webhostingNoLimit: {
        title: 'Webhosting NoLimit',
        content: 'Das beliebteste und meistverkaufte Webhosting in Tschechien, ideal für WordPress, E-Shops und anspruchsvolle Projekte. Unbegrenzter Speicherplatz, stabile Leistung und 24/7-Support.',
        cta: 'Mit 70% Rabatt bestellen'
      },
      webhostingLowCost: {
        title: 'Webhosting LowCost und NoLimit',
        content: '60% Rabatt auf Webhosting LowCost und NoLimit - die ideale Lösung für kleine und große Projekte.',
        cta: 'Mit 60% Rabatt bestellen'
      },
      domains: {
        title: 'Domains',
        content: '50% Rabatt auf Domains .EU, .ONLINE, .STORE, .TECH, .SITE, .WEBSITE, .SPACE und .FUN. Registrieren Sie Ihre Domain zu einem günstigen Preis!',
        cta: 'Mit 50% Rabatt registrieren'
      },
      vpsOn: {
        title: 'VPS ON',
        content: 'Virtuelle Server auf OpenNebula Cloud-Infrastruktur. Zahlen Sie nur für das, was Sie brauchen! Wählen Sie RAM, Festplattenspeicher (100% SSD) und Anzahl der CPU-Kerne.',
        cta: 'VPS ON mit 33% Rabatt erhalten'
      },
      vpsSsd: {
        title: 'VPS SSD',
        content: 'Leistungsstarke virtuelle Server mit dedizierter Leistung und SSD-Festplatten. Garantierte Leistung und Verfügbarkeit für Ihre Projekte.',
        cta: 'VPS SSD mit 25% Rabatt erhalten'
      },
      wordpressHosting: {
        title: 'WordPress Hosting',
        content: 'Spezielle 50% Rabattaktion für WordPress Hosting WP LowCost und WP NoLimit. Ideal für schnelle und sichere WordPress-Websites.',
        cta: 'WordPress Hosting mit 50% Rabatt erhalten'
      },
      website: {
        title: 'VEDOS WebSite',
        content: 'Erstellen Sie Ihre eigene Website einfach und schnell. Jetzt mit 50% Rabatt auf den VEDOS WebSite-Service.',
        cta: 'Website mit 50% Rabatt erstellen'
      },
      // cd: {
      //   title: 'VEDOS CD',
      //   content: 'Cloud-Speicher für Ihre Daten. Nutzen Sie 25% Rabatt auf VEDOS CD-Dienste.',
      //   cta: 'Mit 25% Rabatt aktivieren'
      // },
      disk: {
        title: 'VEDOS Disk',
        content: 'Sichere Backup-Speicherung für Ihre Daten. Roher Festplattenspeicher mit FTP-, rsync-, SMB-, SVN- und Git-Zugang. Von 30 GB bis zu TB-Vielfachen.',
        cta: 'Mit 25% Rabatt erhalten'
      },
      mailhosting: {
        title: 'Mailhosting',
        content: 'Moderne E-Mail auf eigener Domain mit tschechischem Support. Stabile und sichere Dienstleistung mit Daten, die ausschließlich im Rechenzentrum in Tschechien gespeichert werden.',
        cta: 'Mailhosting mit 50% Rabatt erhalten'
      },
      renewal: {
        title: 'Dienstverlängerung',
        content: 'Spezieller Rabatt auf die Verlängerung bestehender Dienste (max. 300x).',
        cta: 'Dienste verlängern'
      }
    },
    seo: {
      useCode: 'Nutzen Sie unseren exklusiven Rabattcode',
      saveOnServices: 'und sparen Sie bei Vedos.cz-Diensten. Dieser Gutschein ist gültig bis',
      significantDiscount: 'und bietet einen erheblichen Rabatt auf',
      aboutVedos: 'Vedos.cz ist einer der führenden Anbieter von Webhosting und Domain-Diensten in der Tschechischen Republik. Unsere Rabattgutscheine ermöglichen es Ihnen, qualitativ hochwertige Dienste zu günstigen Preisen zu erhalten.',
      howToUse: 'So verwenden Sie den Rabattcode',
      step1: 'Klicken Sie auf die Schaltfläche',
      step2: 'Wählen Sie den gewünschten Service oder das Paket',
      step3: 'Geben Sie den Rabattcode im Warenkorb ein:',
      step4: 'Schließen Sie die Bestellung mit dem angewendeten Rabatt ab',
      whyChoose: 'Warum Vedos.cz wählen',
      reason1: 'Mehr als 15 Jahre Markterfahrung',
      reason2: 'Zuverlässige Dienste mit hoher Verfügbarkeit',
      reason3: 'Tschechischer technischer Support',
      reason4: 'Wettbewerbsfähige Preise',
      reason5: 'Moderne Technologie und Infrastruktur',
      moreCoupons: 'Weitere Rabattgutscheine',
      exploreMore: 'Entdecken Sie weitere verfügbare Rabatte auf Vedos.cz-Dienste',
      allCoupons: 'Alle Gutscheine',
      above: 'oben',
      faqTitle: 'Häufig gestellte Fragen',
      long: {
        webhostingNoLimit: 'Webhosting NoLimit bietet stabile Leistung, unbegrenzten Speicher und ein hervorragendes Preis‑Leistungs‑Verhältnis für WordPress, WooCommerce und gängige CMS.\n\nDank regelmäßiger Aktionen zählt es zu den günstigsten Angeboten. Die Migration ist in der Regel in wenigen Minuten erledigt.',
        webhostingLowCost: 'LowCost und NoLimit decken die meisten Anforderungen ab. LowCost eignet sich für kleinere Projekte, bei Wachstum empfiehlt sich NoLimit mit stärkeren Parametern.\n\nGutscheincodes reduzieren oft die Einrichtungsgebühr und die erste Abrechnungsperiode.',
        vpsOn: 'VPS ON gibt volle Kontrolle – CPU, RAM und SSD‑Speicher auf zuverlässiger OpenNebula‑Infrastruktur. Geeignet für Anwendungen mit Root‑Zugriff, Isolation und Skalierbarkeit.\n\nDer Rabatt erleichtert Tests produktionsnaher Umgebungen.',
        vpsSsd: 'VPS SSD bietet ein ausgewogenes Preis-Leistungs-Verhältnis mit garantierten Parametern innerhalb von Modulen. Ideal für Projekte, die eine stabile und vorhersagbare Umgebung erfordern. Dank SSD-Festplatten sind Operationen sehr schnell.\n\nDer Rabatt gilt für die Einrichtung des Dienstes und ermöglicht Ihnen den Start mit einem professionellen virtuellen Server zu minimalen Kosten.',
        wordpressHosting: 'WordPress Hosting WP LowCost und WP NoLimit ist speziell für Leistung und Einfachheit bei WordPress ausgelegt. Mit 50 % Rabatt starten Sie Blogs, Firmenwebsites oder WooCommerce-Projekte besonders günstig.\n\nDie Umgebung ist für modernes WordPress optimiert und einfach zu verwalten.',
        domains: 'Die Domainregistrierung ist der erste Schritt zur eigenen Website. Mit unserem Rabatt erhalten Sie beliebte Endungen wie .EU, .ONLINE oder .STORE zu einem Bruchteil des regulären Preises. Der Aktionspreis gilt für das erste Jahr der Registrierung.\n\nDarüber hinaus erhalten Sie zu jeder Domain eine grundlegende DNS-Verwaltung und die Möglichkeit der einfachen Anbindung an andere Vedos-Dienste.',
        website: 'VEDOS WebSite ermöglicht den schnellen Aufbau einer Website ohne Programmierung. Vorlage wählen, Inhalte anpassen und veröffentlichen – ideal für kleine Unternehmen.\n\nDie Aktion macht professionelle Websites deutlich günstiger als Individualentwicklung.',
        disk: 'VEDOS Disk ist sicherer externer Speicher für Backups und Archivierung. Zugriff über FTP, rsync, SMB, SVN oder Git – einfach in Workflows integrierbar.\n\nDer Gutschein senkt die Kosten der Langzeitaufbewahrung.',
        mailhosting: 'Mailhosting auf eigener Domain stärkt das professionelle Auftreten. Moderner Webmail, Anti‑Spam/Anti‑Virus, Daten in Rechenzentren in Tschechien.\n\nMit dem Rabatt richten Sie Firmen‑E‑Mail schnell und günstig ein.',
        renewal: 'Mit dem Verlängerungsrabatt sparen Sie bei gleichbleibenden Parametern. Ideal für langfristige Projekte mit Fokus auf Stabilität. Newsletter beachten – oft mit attraktiven Codes.'
      },
      faqs: {
        webhostingNoLimit: [
          { q: 'Für wen ist NoLimit geeignet?', a: 'Für Unternehmenswebsites, Blogs, Magazine und kleine Shops auf WordPress.' },
          { q: 'Kann ich von LowCost upgraden?', a: 'Ja, ein Upgrade ist jederzeit ohne Ausfall möglich.' },
          { q: 'Gibt es HTTPS und Backups?', a: 'Ja, Let’s Encrypt/SSL und regelmäßige Backups gemäß Servicebedingungen.' }
        ],
        webhostingLowCost: [
          { q: 'Reicht LowCost für kleine Websites?', a: 'Ja, und bei Bedarf können Sie auf NoLimit wechseln.' },
          { q: 'Wie löse ich den Gutschein ein?', a: 'Geben Sie den Code im Warenkorb ein – der Preis aktualisiert sich sofort.' },
          { q: 'Ist die Migration kompliziert?', a: 'Die meisten CMS bieten einfache Schritte. Der Support hilft bei Bedarf.' }
        ],
        domains: [
          { q: 'Für welche Endungen gilt der Rabatt?', a: 'Der Rabatt von 50 % gilt für die Domains .EU, .ONLINE, .STORE, .TECH, .SITE, .WEBSITE, .SPACE und .FUN.' },
          { q: 'Gilt der Rabatt auch für die Verlängerung?', a: 'Der Aktionspreis gilt für das erste Jahr der Domainregistrierung.' },
          { q: 'Wie lange dauert die Registrierung?', a: 'Die Registrierung erfolgt automatisch nach Zahlungseingang, meist innerhalb weniger Minuten.' }
        ],
        vps: [
          { q: 'Warum VPS statt Shared Hosting?', a: 'Volle Root‑Kontrolle, isolierte Umgebung und skalierbare Ressourcen.' },
          { q: 'Welche Technologien sind möglich?', a: 'Beliebige Linux‑Distributionen, Datenbanken, Docker u. v. m.' },
          { q: 'Ist die Leistung garantiert?', a: 'Sie wählen die Parameter. Plattform auf OpenNebula mit SSD‑Storage.' }
        ],
        website: [
          { q: 'Muss ich programmieren können?', a: 'Nein, Vorlage wählen, Inhalte bearbeiten, veröffentlichen – in Minuten.' },
          { q: 'Geeignet für kleine Unternehmen?', a: 'Ja, schneller und budgetfreundlicher Webauftritt.' },
          { q: 'Kann ich später wechseln?', a: 'Ja, bei höheren Anforderungen zu NoLimit und eigenem CMS.' }
        ],
        disk: [
          { q: 'Wofür eignet sich Disk?', a: 'Für Backups, Archivierung und Datenaustausch außerhalb der eigenen Infrastruktur.' },
          { q: 'Ist die Übertragung sicher?', a: 'Ja, es stehen sichere Protokolle und Zugänge zur Verfügung.' },
          { q: 'Wie wähle ich die Kapazität?', a: 'Klein starten und bei Bedarf erweitern. Der Rabatt senkt Einstiegskosten.' }
        ],
        mailhosting: [
          { q: 'Unterstützen Sie eigene Domains?', a: 'Ja, E‑Mails laufen auf Ihrer Domain – professionell und vertrauenswürdig.' },
          { q: 'Gibt es Anti‑Spam?', a: 'Ja, Anti‑Spam und Anti‑Virus sowie moderner Webmail sind enthalten.' },
          { q: 'Wie viele Postfächer sind möglich?', a: 'Die Anzahl lässt sich flexibel erweitern.' }
        ],
        renewal: [
          { q: 'Für welche Dienste gilt der Rabatt?', a: 'Für Verlängerungen bestehender Dienste gemäß Aktionsregeln.' },
          { q: 'Kann ich Rabatte kombinieren?', a: 'Kommt auf die Kampagne an – Details im Newsletter.' },
          { q: 'Ist der Code befristet?', a: 'Ja, die Gültigkeit ist beim Coupon angegeben. Rechtzeitig bestellen.' }
        ]
      }
    }
  },
  it: {
    title: 'Coupon Sconto Attuali per Vedos.cz',
    subtitle: 'Usa i coupon sconto attuali e risparmia su hosting web, domini e altri servizi.',
    cta: 'Vai a Vedos.cz',
    homeTitle: 'Coupon Sconto Vedos 2026 - Fino al 70% di sconto su Webhosting, VPS ON, VPS SSD e Domini',
    skipToContent: 'Vai al contenuto',
    privacyPolicy: 'Informativa sulla privacy',
    discountCode: 'Codice sconto',
    validUntil: 'valido fino al',
    topCoupons: 'Migliori Codici Sconto',
    moreInfo: 'Più informazioni',
    recommended: 'Consigliato',
    site: {
      title: 'slevy-hosting-domeny.cz'
    },
    footer: {
      aboutTitle: 'Informazioni sul progetto',
      aboutText1: 'raccoglie i codici sconto attuali per i servizi Vedos.cz (webhosting, WordPress hosting, VPS, domini e altro).',
      aboutText2: 'Questo sito ha scopo informativo e può contenere link affiliati. Cliccando un link supporti il progetto; per te non cambia nulla.',
      linksTitle: 'Link',
      links: {
        home: 'Home',
        blog: 'Blog',
        privacy: 'Informativa sulla privacy'
      },
      servicesTitle: 'Altri servizi',
      services: {
        vinInfo: 'VIN Info.cz — controllo veicolo',
        fixweb: 'FixWeb.cz — riparazioni siti web',
        dealora: 'Dealora.cz — codici sconto',
        openShops: 'I negozi sono aperti?',
        kurzyKaret: 'KurzyKaret.cz — tassi al pagamento con carta'
      }
    },
    blog: {
      title: 'Blog',
      subtitle: 'Guide pratiche, confronti e consigli per scegliere hosting, WordPress, VPS e domini.',
      pageTitle: 'Blog | slevy-hosting-domeny.cz',
      readMore: 'Leggi articolo',
      openOffer: 'Apri offerta',
      relatedOffers: 'Offerte correlate',
      published: 'Pubblicato',
      updated: 'Aggiornato',
      minutes: 'min di lettura',
      lessThanMinute: '< 1 min di lettura',
      backToBlog: 'Torna al blog',
      noPostsForLanguage: 'Per questa lingua non ci sono ancora articoli disponibili.',
      csOnlyShort: 'Contenuto in ceco',
      csOnlyNotice: 'Questo articolo è attualmente disponibile solo in ceco.',
      languageMismatchNotice: "Questo articolo è disponibile in un'altra lingua. Di seguito vedi la versione originale.",
      notFoundTitle: 'Articolo non trovato',
      notFoundText: 'Scegli uno degli articoli del blog.'
    },
    coupons: {
      webhostingNoLimit: 'Webhosting NoLimit e sconto Extra del 70%',
      webhostingLowCost: 'Webhosting LowCost, NoLimit e sconto Extra del 60%',
      domains: '50% di sconto su domini (.EU, .ONLINE, .STORE, .TECH, .SITE, .WEBSITE, .SPACE, .FUN)',
      vpsOn: 'VPS ON sconto del 33%',
      vpsSsd: 'VPS SSD sconto del 25%',
      wordpressHosting: 'WordPress hosting (WP LowCost + WP NoLimit) sconto del 50%',
      website: 'VEDOS WebSite sconto del 50%',
      disk: 'VEDOS Disk sconto del 25%',
      mailhosting: 'Mailhosting sconto del 50%',
      renewal: 'Sconto RINNOVO',
      renewalInfo: {
        text: '(max. 300x). In alternativa, controlla la',
        linkText: 'newsletter attuale',
        linkUrl: 'https://www.vedos.cz/en/newsletter?ap=Lf2pCY'
      },
      allCodes: 'Codici Sconto Disponibili'
    },
    services: {
      webhostingNoLimit: {
        title: 'Webhosting NoLimit',
        content: 'L\'hosting web più popolare e venduto nella Repubblica Ceca, ideale per WordPress, e-commerce e progetti impegnativi. Spazio illimitato, prestazioni stabili e supporto 24/7.',
        cta: 'Ordina con il 70% di sconto'
      },
      webhostingLowCost: {
        title: 'Webhosting LowCost e NoLimit',
        content: 'Sconto del 60% su Webhosting LowCost e NoLimit - soluzione perfetta per progetti piccoli e grandi.',
        cta: 'Ordina con il 60% di sconto'
      },
      domains: {
        title: 'Domini',
        content: '50% di sconto su domini .EU, .ONLINE, .STORE, .TECH, .SITE, .WEBSITE, .SPACE e .FUN. Registra il tuo dominio a un ottimo prezzo!',
        cta: 'Registra con il 50% di sconto'
      },
      vpsOn: {
        title: 'VPS ON',
        content: 'Server virtuali su infrastruttura cloud OpenNebula. Paga solo ciò di cui hai bisogno! Scegli RAM, spazio disco (100% SSD) e numero di core CPU.',
        cta: 'Ottieni VPS ON con il 33% di sconto'
      },
      vpsSsd: {
        title: 'VPS SSD',
        content: 'Potenti server virtuali con prestazioni dedicate e dischi SSD. Prestazioni e disponibilità garantite per i tuoi progetti.',
        cta: 'Ottieni VPS SSD con il 25% di sconto'
      },
      wordpressHosting: {
        title: 'WordPress hosting',
        content: 'Sconto speciale del 50% su WordPress hosting WP LowCost e WP NoLimit. Perfetto per siti WordPress veloci, stabili e sicuri.',
        cta: 'Ottieni WordPress hosting con il 50% di sconto'
      },
      website: {
        title: 'VEDOS WebSite',
        content: 'Crea il tuo sito web facilmente e velocemente. Ora con il 50% di sconto sul servizio VEDOS WebSite.',
        cta: 'Crea sito con il 50% di sconto'
      },
      disk: {
        title: 'VEDOS Disk',
        content: 'Archiviazione sicura per i tuoi dati. Spazio disco con accesso FTP, rsync, SMB, SVN e Git. Da 30 GB a multipli di TB.',
        cta: 'Ottieni con il 25% di sconto'
      },
      mailhosting: {
        title: 'Mailhosting',
        content: 'Email moderna sul tuo dominio con supporto ceco. Servizio stabile e sicuro con dati archiviati esclusivamente nel datacenter nella Repubblica Ceca.',
        cta: 'Ottieni mailhosting con il 50% di sconto'
      },
      renewal: {
        title: 'Rinnovo Servizi',
        content: 'Sconto speciale sul rinnovo dei servizi esistenti (max. 300x).',
        cta: 'Rinnova servizi'
      }
    },
    seo: {
      useCode: 'Usa il nostro codice sconto esclusivo',
      saveOnServices: 'e risparmia sui servizi Vedos.cz. Questo coupon è valido fino al',
      significantDiscount: 'e fornisce uno sconto significativo su',
      aboutVedos: 'Vedos.cz è uno dei principali fornitori di hosting web e servizi di dominio nella Repubblica Ceca. I nostri coupon sconto ti permettono di ottenere servizi di qualità a ottimi prezzi.',
      howToUse: 'Come usare il codice sconto',
      step1: 'Clicca sul pulsante',
      step2: 'Seleziona il servizio o pacchetto desiderato',
      step3: 'Inserisci il codice sconto nel carrello:',
      step4: 'Completa l\'ordine con lo sconto applicato',
      whyChoose: 'Perché scegliere Vedos.cz',
      reason1: 'Oltre 15 anni di esperienza sul mercato',
      reason2: 'Servizi affidabili con alta disponibilità',
      reason3: 'Supporto tecnico ceco',
      reason4: 'Prezzi competitivi',
      reason5: 'Tecnologia e infrastruttura moderne',
      moreCoupons: 'Altri coupon sconto',
      exploreMore: 'Esplora altri sconti disponibili sui servizi Vedos.cz',
      allCoupons: 'Tutti i coupon',
      above: 'sopra',
      faqTitle: 'Domande Frequenti',
      long: {
        webhostingNoLimit: 'Webhosting NoLimit è una scelta bilanciata per progetti che necessitano di prestazioni stabili, spazio illimitato e ottimo rapporto qualità-prezzo. Gestisce facilmente WordPress, WooCommerce e le piattaforme CMS più popolari.\n\nCon promozioni ricorrenti, appartiene alle opzioni più convenienti sul mercato. La migrazione è semplice e la maggior parte dei siti può essere lanciata in pochi minuti.',
        webhostingLowCost: 'LowCost e NoLimit coprono le esigenze della maggior parte dei siti web. LowCost è perfetto per siti personali, blog e piccole pagine aziendali. Se prevedi una crescita, considera NoLimit con parametri database e PHP più potenti.\n\nI codici sconto riducono solitamente la tariffa di attivazione e il primo periodo di fatturazione, così risparmi fin dall\'inizio.',
        vpsOn: 'VPS ON ti offre pieno controllo – scegli CPU, RAM e storage SSD su una infrastruttura OpenNebula affidabile. È adatto per applicazioni che richiedono accesso root, isolamento e capacità di scalare.\n\nLo sconto ti aiuta a validare ambienti simili alla produzione a un costo inferiore e scalare successivamente.',
        vpsSsd: 'VPS SSD offre un rapporto qualità-prezzo equilibrato con parametri garantiti all\'interno dei moduli. È ideale per progetti che richiedono un ambiente stabile e prevedibile. Grazie ai dischi SSD, le operazioni sono molto veloci.\n\nLo sconto si applica all\'attivazione del servizio e ti permette di iniziare con un server virtuale professionale a un costo minimo.',
        wordpressHosting: 'WordPress hosting WP LowCost e WP NoLimit è pensato per prestazioni elevate su WordPress. Con lo sconto del 50% puoi avviare blog, siti aziendali o WooCommerce a costi contenuti.\n\nL\'ambiente è ottimizzato per WordPress moderno e per una gestione semplice.',
        domains: 'La registrazione del dominio è il primo passo verso il tuo sito web. Con il nostro sconto, puoi ottenere estensioni popolari come .EU, .ONLINE o .STORE a una frazione del prezzo normale. Il prezzo promozionale si applica al primo anno di registrazione.\n\nInoltre, ottieni la gestione DNS di base con ogni dominio e la possibilità di una facile connessione con altri servizi Vedos.',
        website: 'VEDOS WebSite ti permette di costruire un sito web senza codificare. Scegli un template, modifica i contenuti e pubblica. È ideale per liberi professionisti e piccole imprese che vogliono andare online rapidamente.\n\nLa promozione rende i siti web dall\'aspetto professionale molto convenienti rispetto allo sviluppo personalizzato.',
        disk: 'VEDOS Disk è uno storage remoto sicuro per backup e archivi. L\'accesso tramite FTP, rsync, SMB, SVN o Git si integra facilmente con i tuoi flussi di lavoro. Adatto per aziende e privati che necessitano di spazio affidabile al di fuori della propria infrastruttura.\n\nIl coupon riduce il costo totale della conservazione dei dati a lungo termine.',
        mailhosting: 'Il Mailhosting sul tuo dominio migliora la tua immagine professionale. Ottieni webmail moderna, protezione antivirus e antispam, con dati archiviati nella Repubblica Ceca. È facile aggiungere caselle di posta e configurare alias.\n\nCon lo sconto, puoi configurare la posta aziendale rapidamente e a prezzi accessibili.',
        renewal: 'Gli sconti sul rinnovo riducono i costi mantenendo i parametri del servizio correnti. Ottimo per progetti a lungo termine che beneficiano di stabilità e funzionamento ininterrotto. Segui la newsletter – spesso include generosi codici di rinnovo.'
      },
      faqs: {
        webhostingNoLimit: [
          { q: 'Per chi è adatto NoLimit?', a: 'Per siti aziendali, blog, magazine e piccoli e-shop su WordPress, con prestazioni ampie e spazio illimitato.' },
          { q: 'Posso passare da LowCost a NoLimit?', a: 'Sì, puoi aggiornare in qualsiasi momento senza tempi di inattività del servizio.' },
          { q: 'Sono disponibili HTTPS e backup?', a: 'Sì, Let\'s Encrypt/SSL e backup regolari sono disponibili secondo la politica del servizio.' }
        ],
        webhostingLowCost: [
          { q: 'LowCost è sufficiente per un piccolo sito?', a: 'Sì, è adatto per siti personali e di piccole imprese. Puoi passare a NoLimit in seguito.' },
          { q: 'Come applico il coupon?', a: 'Inserisci il codice al momento del pagamento e conferma; il prezzo si aggiorna immediatamente.' },
          { q: 'La migrazione è difficile?', a: 'La maggior parte delle piattaforme CMS ha semplici passaggi di migrazione. Il supporto può aiutare se necessario.' }
        ],
        domains: [
          { q: 'Per quali estensioni vale lo sconto?', a: 'Lo sconto del 50% si applica ai domini .EU, .ONLINE, .STORE, .TECH, .SITE, .WEBSITE, .SPACE e .FUN.' },
          { q: 'Lo sconto si applica anche al rinnovo?', a: 'Il prezzo promozionale si applica al primo anno di registrazione del dominio.' },
          { q: 'Quanto tempo richiede la registrazione?', a: 'La registrazione è automatica dopo l\'abbinamento del pagamento, solitamente in pochi minuti.' }
        ],
        vps: [
          { q: 'Perché scegliere VPS invece dell\'hosting condiviso?', a: 'Ottieni il pieno controllo root, ambiente isolato e risorse scalabili.' },
          { q: 'Quali tecnologie posso usare?', a: 'Qualsiasi distribuzione Linux, database, Docker e altro – secondo la tua configurazione.' },
          { q: 'Le prestazioni sono garantite?', a: 'Selezioni tu i parametri. La piattaforma funziona su OpenNebula con storage SSD.' }
        ],
        website: [
          { q: 'Devo saper programmare?', a: 'No, scegli un template e modifica i contenuti in un editor. Pubblica in pochi minuti.' },
          { q: 'È adatto per piccole imprese?', a: 'Sì, un modo rapido e conveniente per presentare i tuoi servizi e contatti.' },
          { q: 'Posso passare all\'hosting in seguito?', a: 'Sì, passa a NoLimit e al tuo CMS quando hai bisogno di maggiore flessibilità.' }
        ],
        disk: [
          { q: 'A cosa serve Disk?', a: 'Per backup, archiviazione e condivisione di dati al di fuori della tua infrastruttura con più protocolli di accesso.' },
          { q: 'Il trasferimento dati è sicuro?', a: 'Sì, protocolli sicuri e metodi di accesso sono disponibili a seconda della configurazione.' },
          { q: 'Come scegliere la capacità?', a: 'Inizia con un piano più piccolo e scala secondo necessità. Lo sconto riduce i costi iniziali.' }
        ],
        mailhosting: [
          { q: 'Supportate il mio dominio?', a: 'Sì, l\'email funziona sul tuo dominio per una presenza professionale e affidabile.' },
          { q: 'È incluso l\'antispam?', a: 'Sì, protezione antispam e antivirus con webmail moderna sono inclusi.' },
          { q: 'Quante caselle di posta posso avere?', a: 'Puoi facilmente aggiungere più caselle di posta man mano che il tuo team cresce.' }
        ],
        renewal: [
          { q: 'A quali servizi si applica?', a: 'Ai rinnovi dei servizi esistenti secondo le regole promozionali correnti.' },
          { q: 'Posso combinare gli sconti?', a: 'Dipende dalle regole della campagna. Controlla la newsletter per i dettagli.' },
          { q: 'Il codice ha una scadenza?', a: 'Sì, la validità è sempre indicata con il coupon. Ordina in tempo.' }
        ]
      }
    }
  }
}; 